<template>
	<div>
		<!-- <div class="title">尊敬的马帮用户，请联系专属顾问进行充值，谢谢!</div> -->
		<div class="mb-tabs">
			<el-tabs v-model="activeName" @tab-click="handleClick">
				<el-tab-pane :name="item.id + ''" v-for="item in editionList" :key="item.id">
					<template slot="label">
						<el-tooltip
							:content="item.describe"
							placement="bottom"
							effect="light"
							popper-class="tooltip_class"
							:visible-arrow="false"
						>
							<div>
								<div class="label-img">
									<img :src="item.img" />
								</div>
								<div class="label-title">{{ item.name }}</div>

								<div class="label-font">{{ item.describe }}</div>
							</div>
						</el-tooltip>
					</template>
				</el-tab-pane>
			</el-tabs>
		</div>
		<div class="tables">
			<div v-if="paidMemberMessage" class="paid-member-tip">{{ paidMemberMessage }}</div>
			<!-- 客服专业版 -->
			<div v-if="!paidMemberMessage && activeName == 1006">
				<mbCarousel :cardList="price" :totalPrice="totalPrice" @mb-check-card="checkCard" @mb-buy-btn="buyBtn">
					<div slot="buyOption">
						<div class="flex-div">
							<div class="text-height">购买{{ focusCardObj.name }}加购包数：</div>
							<div class="text-between">
								<span>
									<el-input-number v-model="count" :min="1" size="small"></el-input-number>
									个
								</span>
								<span class="ml20">共计：{{ count }} 个</span>
							</div>
						</div>
					</div>
				</mbCarousel>
			</div>
			<div>
				<!-- 其他统一样式的版本 -->
				<div class="tables_box" :style="newstyle" style="margin: 0 auto" v-if="!paidMemberMessage && price.length > 0">
					<div class="tables_center" v-for="item in price" :key="item.id">
						<div class="table_top">
							<div class="top_font">
								<img v-if="item.imgUrl" :src="item.imgUrl" />
								<img v-else src="@/assets/images/1.png" />
								{{ item.name }}
							</div>
							<div class="top_box">
								{{ item.currency === 'USD' ? '$' : '￥' }} <span class="top_center">{{ item.price }}</span>
								<!-- / {{ item.priceUnit }} -->
							</div>
							<div class="top_btn" @click="payBtn(item)">Buy now</div>
						</div>
						<div class="table_cen">
							<div class="cen_title">Benefits</div>
							<div class="cen_content" v-if="item.hasOwnProperty('shopCnt')">
								<div>Stores</div>
								<div class="dataprice">
									<span v-if="item.shopCnt">{{ item.shopCnt }}</span>
									<span v-else class="datapriceimg"></span>
								</div>
							</div>
							<div class="cen_content" v-if="item.hasOwnProperty('employeeCnt')">
								<div>Employees</div>
								<div class="dataprice">
									<span v-if="item.employeeCnt">{{ item.employeeCnt }}</span>
									<span v-else class="datapriceimg"></span>
								</div>
							</div>
							<div class="cen_content" v-if="item.hasOwnProperty('orderCnt')">
								<div>Orders</div>
								<div class="dataprice">
									<span v-if="item.orderCnt">{{ item.orderCnt }}</span>
									<span v-else class="datapriceimg"></span>
								</div>
							</div>
							<div class="cen_content" v-if="item.hasOwnProperty('isWms')">
								<div>WMS</div>
								<div class="dataprice">
									<span v-if="item.isWms == 1" class="sucimg"></span>
									<span v-else class="datapriceimg"></span>
								</div>
							</div>
							<div class="cen_content" v-if="item.hasOwnProperty('listing')">
								<div>Listing quota</div>
								<div class="dataprice">
									<span v-if="item.listing">{{ item.listing }}</span>
									<span v-else class="datapriceimg"></span>
								</div>
							</div>
							<div class="cen_content" v-if="item.hasOwnProperty('imgStorage')">
								<div>Image storage</div>
								<div class="dataprice">
									<span v-if="item.imgStorage">{{ item.imgStorage }}</span>
									<span v-else class="datapriceimg"></span>
								</div>
							</div>
							<div class="cen_content" v-if="item.hasOwnProperty('private')">
								<div>Private cloud</div>
								<div class="dataprice">
									<span v-if="item.private == 1" class="sucimg"></span>
									<span v-else class="datapriceimg"></span>
								</div>
							</div>
							<div class="cen_content" v-if="item.hasOwnProperty('person_account')">
								<div>Sub-accounts</div>
								<div class="dataprice">
									<span v-if="item.person_account">{{ item.person_account }}</span>
									<span v-else class="datapriceimg"></span>
								</div>
							</div>
							<div class="cen_content" v-if="item.hasOwnProperty('development_product')">
								<div>Developed products</div>
								<div class="dataprice">
									<span v-if="item.development_product">{{ item.development_product }}</span>
									<span v-else class="datapriceimg"></span>
								</div>
							</div>
							<div class="cen_content" v-if="item.hasOwnProperty('publish_nums')">
								<div>Published products</div>
								<div class="dataprice">
									<span v-if="item.publish_nums">{{ item.publish_nums }}</span>
									<span v-else class="datapriceimg"></span>
								</div>
							</div>
							<div class="cen_content" v-if="item.hasOwnProperty('selection_product_monitor')">
								<div>Product monitoring</div>
								<div class="dataprice">
									<span v-if="item.selection_product_monitor">{{
										item.selection_product_monitor
									}}</span>
									<span v-else class="datapriceimg"></span>
								</div>
							</div>
							<div class="cen_content" v-if="item.hasOwnProperty('selection_shop_monitor')">
								<div>Store monitoring</div>
								<div class="dataprice">
									<span v-if="item.selection_shop_monitor">{{ item.selection_shop_monitor }}</span>
									<span v-else class="datapriceimg"></span>
								</div>
							</div>
							<div class="cen_content" v-if="item.hasOwnProperty('selection_category_monitor')">
								<div>Category monitoring</div>
								<div class="dataprice">
									<span v-if="item.selection_category_monitor">{{
										item.selection_category_monitor
									}}</span>
									<span v-else class="datapriceimg"></span>
								</div>
							</div>
							<div class="cen_content" v-if="item.hasOwnProperty('selection_keywords_monitor')">
								<div>Keyword monitoring:</div>
								<div class="dataprice">
									<span v-if="item.selection_keywords_monitor">{{
										item.selection_keywords_monitor
									}}</span>
									<span v-else class="datapriceimg"></span>
								</div>
							</div>
							<div class="cen_content" v-if="item.hasOwnProperty('amz_operate_sell_monitor')">
								<div>Amazon hijack monitoring</div>
								<div class="dataprice">
									<span v-if="item.amz_operate_sell_monitor">{{
										item.amz_operate_sell_monitor
									}}</span>
									<span v-else class="datapriceimg"></span>
								</div>
							</div>
							<div class="cen_content" v-if="item.hasOwnProperty('development_project_management')">
								<div>Project management</div>
								<div class="dataprice">
									<span v-if="item.development_project_management == 1" class="sucimg"></span>
									<span v-else class="datapriceimg"></span>
								</div>
							</div>
							<div class="cen_content" v-if="item.hasOwnProperty('portalSite')">
								<div>Portal site</div>
								<div class="dataprice">
									<span v-if="item.portalSite == 1" class="sucimg"></span>
									<span v-else class="datapriceimg"></span>
								</div>
							</div>
							<div class="cen_content" v-if="item.hasOwnProperty('softwareTraining')">
								<div>Online software training</div>
								<div class="dataprice">
									<span v-if="item.softwareTraining == 1" class="sucimg"></span>
									<span v-else class="datapriceimg"></span>
								</div>
							</div>
							<div class="cen_content" v-if="item.hasOwnProperty('warehouseTraining')">
								<div>On-site warehouse training</div>
								<div class="dataprice">
									<span v-if="item.warehouseTraining == 1" class="sucimg"></span>
									<span v-else class="datapriceimg"></span>
								</div>
							</div>
							<div class="cen_content" v-if="item.hasOwnProperty('service1v1')">
								<div>1-on-1 support</div>
								<div class="dataprice">
									<span v-if="item.service1v1 == 1" class="sucimg"></span>
									<span v-else class="datapriceimg"></span>
								</div>
							</div>

							<div class="cen_content" v-if="item.hasOwnProperty('dmsShopCnt')">
								<div>Stores</div>
								<div class="dataprice">
									<span v-if="item.dmsShopCnt">{{ item.dmsShopCnt }}</span>
									<span v-else class="datapriceimg"></span>
								</div>
							</div>
							<div class="cen_content" v-if="item.hasOwnProperty('dmsEmployeeCnt')">
								<div>Employees</div>
								<div class="dataprice">
									<span v-if="item.dmsEmployeeCnt">{{ item.dmsEmployeeCnt }}</span>
									<span v-else class="datapriceimg"></span>
								</div>
							</div>
							<div class="cen_content" v-if="activeName == 1006">
								<div>Shopee support</div>
								<div class="dataprice">
									<span>All countries</span>
								</div>
							</div>
							<div class="cen_content" v-if="activeName == 1006">
								<div>Lazada support</div>
								<div class="dataprice">
									<span>All countries</span>
								</div>
							</div>
							<div class="cen_content" v-if="activeName == 1006">
								<div>AliExpress support</div>
								<div class="dataprice">
									<span>All countries</span>
								</div>
							</div>
							<div class="cen_content">
								<div>Validity</div>
								<div class="dataprice">
									<span v-if="item.useTime">{{ item.useTime }}</span>
									<span v-else class="datapriceimg"></span>
								</div>
							</div>

							<!-- <div class="cen_content">
								<div>开发项目</div>
								<div class="dataprice">
									<span v-if="item.developProduct"> {{ item.developProduct }}</span>
									<span v-else class="datapriceimg"></span>
								</div>
							</div> -->
							<!-- <div class="cen_content">
								<div>Product monitoring</div>
								<div class="dataprice">
									<span v-if="item.productMonitor">{{ item.productMonitor }}</span>
									<span v-else class="datapriceimg"></span>
								</div>
							</div>
							<div class="cen_content">
								<div>Store monitoring</div>
								<div class="dataprice">
									<span v-if="item.shopMonitor">{{ item.shopMonitor }}</span>
									<span v-else class="datapriceimg"></span>
								</div>
							</div>
							<div class="cen_content">
								<div>类别监控</div>
								<div class="dataprice">
									<span v-if="item.categoryMonitor">{{ item.categoryMonitor }}</span>
									<span v-else class="datapriceimg"></span>
								</div>
							</div> -->
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { editions, userInfo } from '@/utils/api';
import { mabangPay } from '@/utils/constant';
// import mbCarousel from '@/components/mb-carousel'
export default {
	// components: {
	// 	mbCarousel,
	// },
	data() {
		return {
			activeName: '',
			editionList: [],
			price: [],
			focusCardObj: {},
			count: 1,
			paidMemberMessage: '',
		}
	},
	watch: {},
	computed: {
		newstyle() {
			return `width:${260 * this.price.length + 20 * this.price.length}px`
		},
		totalPrice() {
			return this.focusCardObj.price * this.count
		},
	},
	mounted() {
		this.reqeditions()
	},
	methods: {
		//切换页签
		handleClick() {
			let arr = this.editionList.filter((item) => item.id == this.activeName)
			this.price = arr[0].list
			if (window._hmt) {
				window._hmt.push(['_trackEvent', 'click', '切换', arr[0].name])
			}
		},
		markPaidMember(message) {
			this.paidMemberMessage = message || 'You are already a paid member.'
			this.price = []
			this.editionList = (this.editionList || []).map((item) => {
				return Object.assign({}, item, { list: [] })
			})
		},
		reqeditions() {
			let obj = JSON.parse(sessionStorage.getItem('projectInfo'))
			let sourceInfo = JSON.parse(sessionStorage.getItem('sourceInfo') || '{}')
			let params = {
				moduleId: obj.id,
				source: sourceInfo.sourceId,
			}
			userInfo({ source: sourceInfo.sourceId }).then((info) => {
				if (info && Number(info.isPaidMember) === 1) {
					this.markPaidMember(info.paidMemberMessage)
				}
			}).catch(() => {})
			editions(params).then((res) => {
				if (this.paidMemberMessage) {
					this.markPaidMember(this.paidMemberMessage)
					return
				}
				this.editionList = res || []
				if (this.editionList.length && Number(this.editionList[0].isPaidMember) === 1) {
					this.markPaidMember(this.editionList[0].paidMemberMessage)
					return
				}
				// 版本ID匹配
				if (this.$route.query.editionId) {
					this.activeName = this.$route.query.editionId
					let arr = this.editionList.filter((item) => item.id == this.$route.query.editionId)
					this.price = arr[0] && arr[0].list ? arr[0].list : []
				} else if (this.editionList.length) {
					this.activeName = res[0].id + ''
					this.price = res[0].list || []
				} else {
					this.price = []
				}
			})
		},
		//购买
		payBtn(item) {
			if (this.paidMemberMessage) {
				this.$message.warning(this.paidMemberMessage)
				return
			}
			/**
			 * 1: 可点击
			 * 2：不可点击
			 */
			if (item.canBuy === 2) {
				this.$message.warning('This plan is not compatible with your current version.')
			} else {
				console.log(item)
				let params = {
					goodsId: item.id,
					buyNum: '1',
					moduleId: JSON.parse(sessionStorage.getItem('projectInfo')).id,
				}
				mabangPay(params)
			}
		},
		checkCard(card) {
			this.focusCardObj = card
		},
		buyBtn() {
			let params = {
				goodsId: this.focusCardObj.id,
				buyNum: this.count,
				moduleId: JSON.parse(sessionStorage.getItem('projectInfo')).id,
			}
			mabangPay(params)
		},
	},
}
</script>
<style scoped>
.title {
	color: red;
	text-align: center;
	font-weight: bold;
	margin-top: 20px;
}
.paid-member-tip {
	color: #e6a23c;
	text-align: center;
	font-weight: bold;
	margin: 40px 0;
	font-size: 16px;
}
.tables {
	width: 100%;
	overflow-x: auto;
	padding-top: 15px;
}
.tables_box:after {
	content: '';
	display: block;
	height: 0;
	clear: both;
	visibility: hidden;
}
.tables_center {
	float: left;
	margin: 0 20px 20px 0;
	transition: all 0.3s;
}
.tables_center:hover .table_top {
	color: #fff;
	background: #1a2d4b url('~@/assets/images/logo -diwen2.png') no-repeat right bottom;
	box-shadow: none;
	border: 1px solid #1a2d4b;
}
.tables_center:hover .top_btn {
	background: #e99d56;
	border: 2px solid #e99d56;
}
.tables_center:hover .table_cen {
	background: #1a2d4b;
	border: 1px solid #1a2d4b;
	color: #fff;
}
.tables_center:hover .cen_title {
	background: #1a2d4b url('~@/assets/images/xian 2.png') no-repeat center center;
}
.tables_center:hover .dataprice {
	color: #e99d56;
}
.tables_center:hover .datapriceimg {
	background: #1a2d4b url('~@/assets/images/cha- 拷贝 81.png') no-repeat center center;
}
.datapriceimg {
	transition: all 0.3s;
	width: 12px;
	height: 12px;
	background: #fff url('~@/assets/images/cha- 拷贝 8.png') no-repeat center center;
	display: inline-block;
}

.tables_center:hover .sucimg {
	background: #1a2d4b url('~@/assets/images/succ1.png') no-repeat center center;
}
.sucimg {
	transition: all 0.3s;
	width: 12px;
	height: 12px;
	background: #fff url('~@/assets/images/succ2.png') no-repeat center center;
	display: inline-block;
}

.table_cen {
	transition: all 0.3s;

	width: 259px;
	background: #ffffff;
	border: 1px solid #e8ebf1;
	border-radius: 0px 0px 10px 10px;
	padding: 0 21px;
	box-sizing: border-box;
}
.table_top {
	transition: all 0.3s;
	width: 259px;
	height: 322px;
	border: 1px solid #e8ebf1;
	box-shadow: 0px 10px 9px 1px rgba(194, 192, 192, 0.25);
	border-radius: 10px 10px 0px 0px;
	background: #fff url('~@/assets/images/logodiwen.png') no-repeat right bottom;
	position: relative;
	box-sizing: border-box;
}
.top_font {
	height: 36px;
	font-size: 22px;
	line-height: 36px;
	text-align: center;
	margin-top: 70px;
}
.top_font img {
	vertical-align: middle;
	width: 38px;
	height: 32px;
}
.top_box {
	font-size: 18px;
	text-align: center;
	margin-top: 24px;
	font-weight: bold;
}
.top_center {
	font-size: 30px;
	line-height: 36px;
}
.top_btn {
	width: 134px;
	height: 43px;
	border: 2px solid #42464b;
	border-radius: 22px;
	cursor: pointer;
	margin: 50px auto 0;
	font-size: 20px;
	text-align: center;
	line-height: 43px;
}
.cen_title {
	transition: all 0.3s;

	height: 17px;
	font-size: 18px;
	line-height: 17px;
	background: #fff url('~@/assets/images/xian 1.png') no-repeat center center;
	margin-top: 23px;
	text-align: center;
	margin-bottom: 15px;
}
.cen_content {
	line-height: 39px;
	height: 39px;
	display: flex;
	justify-content: space-between;
	font-size: 16px;
}
.tables::-webkit-scrollbar {
	width: 10px;
	height: 10px;
}

.tables::-webkit-scrollbar-track {
	/* background: #999; */

	border-radius: 2px;
}

.tables::-webkit-scrollbar-thumb {
	background: #ccc;
	border-radius: 10px;
}

.tables::-webkit-scrollbar-thumb:hover {
	background: #ccc;
}

/* .tables::-webkit-scrollbar-corner {
	background: #179a16;
} */
</style>
